module.exports = __webpack_public_path__ + "static/media/telangana.f7740fbf.png";